import { action } from 'easy-peasy'
import type { Action } from 'easy-peasy'
import type { FuseConfig } from '@strata-monorepo/shared-types/src/fuse'
import { getFuseConfig } from '@strata-monorepo/utils/getFuseConfig'

export interface PhoneConfigModel {
  // State
  bannerFuseConfig: FuseConfig | undefined

  // Actions
  setFuseConfigs: Action<PhoneConfigModel, FuseConfig[]>
}

const phoneConfigModel = (): PhoneConfigModel => {
  return {
    // State
    bannerFuseConfig: undefined,

    // Actions
    setFuseConfigs: action((state, payload) => {
      state.bannerFuseConfig = getFuseConfig(payload, 'banner')
    }),
  }
}

export default phoneConfigModel
